import React, { useState } from "react";
import Header from "../components/Header";
import SlideToOpen from "../components/SlideToOpen";
import { homeSections } from "../mock";
import { Instagram } from "lucide-react";

const API = process.env.REACT_APP_BACKEND_URL;

const WaitlistWidget = ({ source, cta }) => {
  const [email, setEmail] = useState("");
  const [state, setState] = useState({ status: "idle", msg: "" });

  const submit = async (e) => {
    e.preventDefault();
    const value = email.trim().toLowerCase();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
      setState({ status: "error", msg: "That email doesn't look right." });
      return;
    }
    setState({ status: "loading", msg: "" });
    try {
      const r = await fetch(`${API}/api/forms/waitlist`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email: value, source }),
      });
      if (!r.ok) throw new Error("failed");
      const data = await r.json();
      setState({
        status: "ok",
        msg: data.already
          ? "You're already on the list — we'll be in touch."
          : "You're on the list — check your inbox soon.",
      });
      setEmail("");
    } catch {
      setState({ status: "error", msg: "Something went wrong. Try again later." });
    }
  };

  return (
    <form className="waitlist-widget" onSubmit={submit} data-testid="fashion-waitlist-form">
      <label className="waitlist-cta">{cta}</label>
      <div className="waitlist-row">
        <input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="you@email.com"
          aria-label="Email for waitlist"
          data-testid="fashion-waitlist-input"
        />
        <button
          type="submit"
          disabled={state.status === "loading"}
          data-testid="fashion-waitlist-submit"
        >
          {state.status === "loading" ? "…" : "Notify me"}
        </button>
      </div>
      {state.msg && (
        <p
          className={`waitlist-msg ${state.status === "ok" ? "is-ok" : "is-err"}`}
          data-testid="fashion-waitlist-msg"
        >
          {state.msg}
        </p>
      )}
    </form>
  );
};

const Home = () => {
  React.useEffect(() => {
    document.title = "The Monde Mania";
  }, []);

  return (
    <>
      <Header hoverColor="rgba(222,78,80,1)" compact={true} />
      <img src="/img/tmm.png" className="banner banner-tmm" alt="The Monde Mania" />

      <div className="sc">
        {homeSections.map((section) => (
          <div key={section.id} className="sc-box-home">
            <img
              src={section.image}
              className="card-img"
              alt={section.alt}
            />
            <div className="text-div">
              <h1 className="headers">{section.title}</h1>
              {section.paragraphs.map((p, i) => (
                <p key={i} className="text">
                  {i === 0 && section.textMark && (
                    <img
                      src={section.textMark}
                      alt={section.textMarkAlt || ""}
                      className="home-text-mark"
                      data-testid={`home-${section.id}-text-mark`}
                    />
                  )}
                  {p}
                </p>
              ))}

              {section.instagram && (
                <a
                  className="card-ig-link"
                  href={section.instagram}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid={`home-${section.id}-ig-link`}
                >
                  <Instagram size={16} />
                  <span>{section.instagramHandle || section.instagram.replace(/^https?:\/\/(www\.)?/, "")}</span>
                </a>
              )}

              {section.showWaitlist && (
                <WaitlistWidget
                  source={section.waitlistSource}
                  cta={section.waitlistCta}
                />
              )}

              <div className="button-row">
                <SlideToOpen
                  to={section.route}
                  external={!!section.external}
                  label="SLIDE"
                  ariaLabel={`Slide to open ${section.title}`}
                />
              </div>
            </div>
          </div>
        ))}
      </div>
    </>
  );
};

export default Home;
